/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMailingListDialogDataDto as FeatureMailingListsCreateMailingListDialogDataDto } from '../../models/feature/mailing-lists/create-mailing-list-dialog-data-dto';

export interface GetData$Params {
}

export function getData(http: HttpClient, rootUrl: string, params?: GetData$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsCreateMailingListDialogDataDto>> {
  const rb = new RequestBuilder(rootUrl, getData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureMailingListsCreateMailingListDialogDataDto>;
    })
  );
}

getData.PATH = '/create-mailing-list-dialog';

